import { useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { api, errMsg } from "@/lib/api";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified || ["admin", "moderator", "operator"].includes(user.role)) return null;
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      data.ok ? toast.success(t("auth.resent")) : toast.error(t("common.error"));
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <div className="bg-[#FFF0EE]" data-testid="verify-email-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-2.5 text-sm sm:px-6">
        <MailWarning className="h-4 w-4 text-[#E0533F]" />
        <span className="text-[#1E1B2E]">{t("auth.verifyBanner")}</span>
        <button onClick={resend} disabled={busy} data-testid="resend-verification-btn" className="font-semibold text-[#E0533F] underline-offset-2 hover:underline">{t("auth.resend")}</button>
      </div>
    </div>
  );
};
